module.exports = "<footer class=\"text-center text-lg-right\">\n\n</footer>"